

import cookie from  'js-cookie'
import store from '@/store/index.js'
import * as types from '@/store/mutation-types';

let url = require('url');

// let fullPath = location.href.split("#")[1];
// if(fullPath == undefined) fullPath = '/';

  function hasAuthed(){
      let fmId = cookie.get('fmId');
      // console.log(userId,'from cookie');
      if(fmId){
        //已经授权，不需要再授权
        store.commit({
          type: types.UPDATE_USERINFO,
          userInfo: {
              memberId: fmId
          }
        });
        return true;
      }else{
        //需要授权
        return false;
      }
  }


  function hasUserIdInUrl(fullPath, next){
    // let fullPath = to.fullPath; //=> /book-detail/23 ? param1=value1 & param2=value2
    let urlObj = url.parse(fullPath, true);

    // console.log("in hasUserIdInUrl urlObj.query.userId and fullPath:", urlObj.query.userId,fullPath);
    if(urlObj.query['userId']){

      //将用户的信息放到cookie去
      cookie.set('fmId',urlObj.query['userId']);
      //放到store中去
      store.commit({
        type: types.UPDATE_USERINFO,
        userInfo: {
            memberId: urlObj.query['userId']
        }
      });
      return true
    }else{
        //到这里要重定向到auth页面，那里会发起微信授权
        // let protocol1 = location.protocol;
        // let host1 = location.host;
        // let reloadUrl1 = protocol1 + "//" + host1 + "/#/auth" + "?fullPath=" + fullPath;
        // location.href = reloadUrl1;
        next({
          name: 'auth',
          query: {
            fullPath: fullPath
          }
        });
    }
  };

  function isInWhiteList(fullPath){
    let pathname = fullPath.split("?")[0];
    let list = ['auth','charm'];
    if(pathname.indexOf("auth") > -1){
      return true;
    }else{
      return false;
    }
  }

  export default function auth(to, from, next){
    // console.log(fullPath, 'in auth')
    // if( !hasAuthed() ){
    //     //如果没有找到cookie中的userid,则看一下链接上是否存在 userId
    //     hasUserIdInUrl();
    //     return;
    // }
    isInWhiteList(to.fullPath) || hasAuthed() || hasUserIdInUrl(to.fullPath, next) ;

    //来到这里，说明在cookie中存在userId,
  }


// WEBPACK FOOTER //
// ./src/auth.js